const resourcesKey = '/resources';

export const resourceRequestMove = () => {
  return `${resourcesKey}/request-move`;
};

export const resourceRequestEdit = () => {
  return `${resourcesKey}/request-edit`;
};

export const resourceRequestDeactivate = () => {
  return `${resourcesKey}/request-deactivate`;
};

export const resourceRequestDeactivateMultiple = () => {
  return `${resourcesKey}/request-deactivate-multiple`;
};
